import { render, staticRenderFns } from "./MainTab.vue?vue&type=template&id=ac259c12&scoped=true"
import script from "./MainTab.vue?vue&type=script&lang=js"
export * from "./MainTab.vue?vue&type=script&lang=js"
import style0 from "./MainTab.vue?vue&type=style&index=0&id=ac259c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac259c12",
  null
  
)

export default component.exports